import config from "@/config";
import axios from "axios";
import store from "@/store";
axios.defaults.timeout = 30000;
export default {
  getSignedRequest: function(data, callback) {
    const getMemberid = () => {
      const memberid = store.state.memberid
      let index = -1
      for (let i = 0; i < memberid.length; i++) {
        if (memberid[i] !== '0') {
          index = i
          break;
        }
      }
      return memberid.slice(index)
    }
    const memberid = getMemberid()
    const headers = {
      Authorization: `Bearer ${memberid || "xxx"} ${store.state.sessiontoken || "xxx"}`,
    };

    let url = config.serverUrl + "containers/upload?file-name=" + data.name;

    const formData = new FormData();
    formData.append("file", data.file);

    // let url =
    //   config.serverUrl +
    //   "liff/sign-s3-v2?file-name=" +
    //   data.name +
    //   "&file-type=" +
    //   data.type;

    axios
      .post(url, formData, { headers })
      .then((response) => {
        // JSON responses are automatically parsed.
        var response = response.data;
        response.file = data.file;
        // this.uploadfile(response, function() {
        callback(null, [response.url, data.name]);
        // });
      })
      .catch((e) => {
        callback(new Error("session expire. Please login again."));
      });
  },

  async getdbdData(id) {
    let url = config.serverUrl + "justric/profile/information?id_card=" + id;

    let response = await axios.get(url).catch((e) => {
      console.error(e);
    });
    if (response) {
      response = response.data;
      return response;
    } else {
      return {};
    }
  },

  async getDraft(memberid, projectid, formid) {
    let url =
      config.serverUrl +
      `draft/depaApplyProjectWithDetail?projectid=${projectid}&memberid=${memberid}&formid=${formid}`;
    axios.defaults.headers.common = {
      AUTHORIZATION: "xxx xxx xxx",
    };
    let response = await axios.get(url).catch((e) => {
      console.error(e);
    });
    if (response) {
      response = response.data;
      return response.data;
    } else {
      return {};
    }
  },

  async saveConsent(data, memberid, sessiontoken) {
    let url = config.serverUrl + "member/consent";
    const headers = {
      Authorization: `Bearer ${memberid || "xxx"} ${sessiontoken || "xxx"}`,
    };
    try {
      let res = await axios.post(url, data, { headers });
      if (res.data.responsecode == 200) {
        return res.data.responsecode;
      }
    } catch (error) {
      console.error(error);
    }
  },

  async getEdit(memberid, applicantid, formid) {
    let url =
      config.serverUrl +
      `edit/depaApplyProjectWithDetail?applicantid=${applicantid}&memberid=${memberid}&formid=${formid}`;
    axios.defaults.headers.common = {
      AUTHORIZATION: "xxx xxx xxx",
    };
    let response = await axios.get(url).catch((e) => {
      console.error(e);
    });
    if (response) {
      response = response.data;
      return response.data;
    } else {
      return {};
    }
  },

  uploadfile: function(data, callback) {
    let signedRequest = data.signedRequest;
    const formData = new FormData();
    formData.append("acl", "public-read");
    Object.keys(signedRequest.fields).forEach((key) => {
      formData.append(key, signedRequest.fields[key]);
    });

    // Actual file has to be appended last.
    formData.append("file", data.file);
    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + ', ' + pair[1]);
    // }

    const xhr = new XMLHttpRequest();
    xhr.upload.addEventListener(
      "progress",
      (event) => {
        var percent = (event.loaded / event.total) * 100;
        store.state.progress = percent;
      },
      false
    );
    xhr.open("POST", signedRequest.url, true);
    xhr.send(formData);
    xhr.onload = function() {
      if (xhr.readyState === 4) {
        if (xhr.status === 200 || xhr.status === 204) {
          callback();
        } else {
          alert("Could not upload file.");
        }
      }
    };
  },

  async getPayment(memberid, sessiontoken) {
    let url = config.serverUrl + "payment/register";
    const headers = {
      Authorization: `Bearer ${memberid || "xxx"} ${sessiontoken || "xxx"}`,
    };
    try {
      let res = await axios.post(url, memberid, {
        headers,
      });
      if (res.data.responsecode == 200) {
        return { data: res.data };
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  async updateSlip(data, memberid, sessiontoken) {
    let url =
      config.serverUrl + "payment/" + data.transaction_id + "/updateSlip";
    const dataSend = {
      slipfile: data.slipfile,
      //paid_date: data.paid_date,
      //paid_time: data.paid_time,
      //bankname: data.bankname,
    };
    const headers = {
      Authorization: `Bearer ${memberid || "xxx"} ${sessiontoken || "xxx"}`,
    };
    try {
      let res = await axios.post(url, dataSend, { headers });
      if (res.data.responsecode == 200) {
        return { data: res };
      } else {
        console.log(res);
        return { data: res };
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  async downloadSlip(memberid, sessiontoken, transactionId) {
    let url =
      config.serverUrl +
      "payment/" +
      transactionId +
      "/download";
    const headers = {
      Authorization: `Bearer ${memberid || "xxx"} ${sessiontoken || "xxx"}`,
    };
    try {
      let res = await axios.post(url, {}, { headers, responseType: "blob" });
      if (res.data) {
        return { data: res.data };
      } else {
        return { data: res.data };
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  },
  async getPaymentStatus(params, memberid, sessiontoken ) {
    let url = config.serverUrl + "payment/checkstatus";
    const headers = {
      Authorization: `Bearer ${memberid || "xxx"} ${sessiontoken || "xxx"}`,
    };
    try {
      let res = await axios.get(url, { headers, params: params });
      if (res.data) {
        return res.data;
      }
    } catch (error) {
      console.error(error);
    }
  },

  async sendodoo(data) {
    let url = config.serverUrl + "sendodoo";
    const headers = {
      Authorization: `Bearer ${store.state.userData.memberid || "xxx"} ${store
        .state.userData.sessiontoken || "xxx"}`,
    };
    try {
      let res = await axios.get(url, { params:  data , headers });
      if (res.data.responsecode == 200) {
        return res.data.data;
      }
    } catch (error) {
      console.error(error);
    }
  },
};
